import React from 'react'
import { Box } from '@usap/uicomponents'
import FaqBox from './style/FAQ.css'

export default function FAQ({ data }) {
  return (
    <>
      <Box id="FAQ" width="100%">
        <FaqBox
          size="small"
          color="dark-2"
          width="100%"
        >
          {/**
           * previously dangerouslySetInnerHTML was inside FaqBox which was causing issues as
           * dangerouslySetInnerHTML cannot be added in jsx tags in this case it was grommet
           * Box so I have created another div and added it inside div. All of the needed
           *  CSS properties are automatically inherited from FaqBox
           */}
          <div dangerouslySetInnerHTML={{ __html: data }} />
        </FaqBox>
      </Box>
    </>
  )
}
